import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row",
  id: "parentConsentCheckbox"
}

import { computed, ref, watch } from "vue";
import Checkbox from "@/components/inputs/Checkbox.vue";
import { ConsentTypeIds } from "@/config/constants";
import type { FieldSchema, FormSchema } from "@/models/form";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'ParentAttestationConsent',
  props: {
    disabled: { type: Boolean, default: false },
    modelValue: { type: Boolean, default: undefined },
    entityTypeId: {},
    entityId: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const checkboxRef = ref<InstanceType<typeof Checkbox>>();

const store = useStore();

const consent = computed(() => store.state.loanConfigurationModule.studentInfo.parentAttestation);

const props = __props;

const emit = __emit;

const parentConsent = ref<boolean | undefined>(undefined);
const parentConsentId = ref<number>();

const errors = computed<Record<string, string>>(() => checkboxRef.value?.errors || {});

const schema = ref<FormSchema>({
  parentConsent: {
    name: "parentConsent",
    type: "checkbox",
    label:
      "By checking this box, you affirm that you are the student's parent or legal guardian and that you claim the student as a dependent on your tax return.",
    errorMessage: "You must check the box to continue.",
    required: true,
    validate: (schema: FieldSchema) => {
      schema.valid = !errors.value.parentConsent;
      schema.errors = errors.value.parentConsent ? [errors.value.parentConsent] : [];

      if (!schema.valid) {
        schema.touched = true;
      } else {
        schema.valid = undefined;
        schema.errors = [];
      }
    },
  } as FieldSchema,
} as FormSchema);

function handleChange(consentGiven: undefined | boolean) {
  emit("update:modelValue", consentGiven);
}

async function getParentAttestationConsents() {
  const parentConsentTypeId = ConsentTypeIds.PARENT_ATTESTATION;

  parentConsentId.value = parentConsentTypeId;

  if (consent.value) {
    parentConsent.value = consent.value?.consentGiven;
    parentConsentId.value = consent.value?.id;
    emit("update:modelValue", consent.value?.consentGiven);
  } else {
    emit("update:modelValue", undefined);
  }
}

watch(
  () => props.modelValue,
  () => {
    parentConsent.value = props.modelValue;
  },
  {
    immediate: true,
  },
);

__expose({
  errors,
  getParentAttestationConsents,
  parentConsent,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Checkbox, {
      ref_key: "checkboxRef",
      ref: checkboxRef,
      name: schema.value.parentConsent.name || 'parentConsent',
      modelValue: parentConsent.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((parentConsent).value = $event)),
      schema: schema.value.parentConsent,
      disabled: __props.disabled,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (handleChange(parentConsent.value)))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(schema.value.parentConsent.label), 1)
      ]),
      _: 1
    }, 8, ["name", "modelValue", "schema", "disabled"])
  ]))
}
}

})